const logoStyle = {
  transform: 'scale(2.4)',
  height: '80%',
  paddingTop: '3px',
  paddingLeft: '10px',

};

const brandStyle = {
  width: '120px',
};
export default {
  logoStyle,
  brandStyle,
};



// WEBPACK FOOTER //
// ./src/scenes/components/Header/style.js